var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5222 8.77491L17.4785 2H16.0671L10.8952 7.88256L6.76437 2H2L8.24656 10.8955L2 18H3.41155L8.87321 11.7878L13.2356 18H18L11.5218 8.77491H11.5222ZM9.58887 10.9738L8.95596 10.0881L3.92015 3.03974H6.0882L10.1522 8.72795L10.7851 9.61374L16.0677 17.0075H13.8997L9.58887 10.9742V10.9738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.1ec699adbe85da543c019d25119b0eeb.svg";
export { ForwardRef as ReactComponent };